export default {
  situacao: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  obraID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  FuncionarioID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  responsavelID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  favorecidoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  secaoRH: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  secaoRHID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicioSolicitacao: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  dataFimSolicitacao: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  despesaLog: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelexpensezpag/components/ExpenseSearch/form.js